import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconFile } from "@tabler/icons-react";
import { ClientesVmiDef } from "./ClientesVmiDef";

export const ClientesVmiIcon = IconFile;
export const ClientesVmiHelpText = '* Importación de Archivos.';

export class ClientesVmi extends Entity<ClientesVmiDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesVmiDef(), parentKeys);
        this.Form = import('./ClientesVmiForm').then((module) => module.ClientesVmiForm);
        this.Title = "Importación de Archivos";
        this.HelpText = ClientesVmiHelpText;
        this.Icon = ClientesVmiIcon;
    }
}